module.exports = __webpack_public_path__ + "img/login-introduce-text2.61b7bcbc.png";